import React from "react";
import validate from "./validateInfo";
import useForm from "./useForm";
import "./Signup.css";
import { motion } from "framer-motion";
import { animationVariants } from "../../constants/animationVariants";
import { useTranslation } from "react-i18next";

const FormSignUp = ({ submitForm }) => {
  const { t } = useTranslation();

  const { handleChange, handleBlur, handleSubmit, values, errors } = useForm(
    submitForm,
    validate
  );

  return (
    <div className="form-content-right">
      <motion.form
        onSubmit={handleSubmit}
        className="form"
        noValidate
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.2 }}
      >
        <motion.h3 className="form-title" variants={animationVariants.fadeUp}>
          {t("form.leave")}
        </motion.h3>
        <motion.div
          className="form-inputs"
          variants={animationVariants.fadeLeft}
        >
          <label className="form-label">{t("form.name")}</label>
          <input
            className="form-input"
            type="text"
            name="name"
            placeholder={t("form.place_name")}
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {errors.name && <p>{t(errors.name)}</p>}
        </motion.div>

        <motion.div
          className="form-inputs"
          variants={animationVariants.fadeRight}
        >
          <label className="form-label">{t("form.email")}</label>
          <input
            className="form-input"
            type="email"
            name="email"
            placeholder={t("form.place_email")}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {errors.email && <p>{t(errors.email)}</p>}
        </motion.div>

        <motion.div
          className="form-inputs"
          variants={animationVariants.fadeLeft}
        >
          <label className="form-label">{t("form.phone")}</label>
          <input
            className="form-input"
            type="text"
            name="phone"
            placeholder={t("form.phone")}
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {errors.phone && <p>{t(errors.phone)}</p>}
        </motion.div>

        <motion.div
          className="form-inputs"
          variants={animationVariants.fadeRight}
        >
          <label className="form-label">{t("form.subject")}</label>
          <input
            className="form-input"
            type="text"
            name="subject"
            placeholder={t("form.subject")}
            value={values.subject}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {errors.subject && <p>{t(errors.subject)}</p>}
        </motion.div>

        <motion.div
          className="form-inputs"
          variants={animationVariants.fadeLeft}
        >
          <label className="form-label">{t("form.message")}</label>
          <textarea
            className="form-input-area"
            rows={2}
            name="message"
            placeholder={t("form.place_message")}
            value={values.message}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {errors.message && <p>{t(errors.message)}</p>}
        </motion.div>
        <motion.button
          className="form-input-btn"
          type="submit"
          variants={animationVariants.fadeUp}
        >
          {t("form.submit")}
        </motion.button>
      </motion.form>
    </div>
  );
};

export default FormSignUp;
